import { render, staticRenderFns } from "./ActionsListComponent.vue?vue&type=template&id=cf480aba"
import script from "./ActionsListComponent.vue?vue&type=script&lang=js"
export * from "./ActionsListComponent.vue?vue&type=script&lang=js"
import style0 from "./ActionsListComponent.vue?vue&type=style&index=0&id=cf480aba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports